import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import LiveNewsFeed from "@/components/LiveNewsFeed";
import { Bitcoin } from "lucide-react";

const ICON = { Bitcoin: "₿", Ethereum: "Ξ", Solana: "◎", BNB: "⬢", XRP: "✕", Cardano: "₳", Dogecoin: "Ð", Polygon: "⬟" };

export default function Crypto() {
  const { data } = useQuery({
    queryKey: ["crypto-prices"],
    queryFn: async () => (await api.get("/market/crypto")).data,
    refetchInterval: 45_000,
  });
  const items = data?.data || [];
  return (
    <div className="px-4 sm:px-6 lg:px-12 py-8">
      <div className="flex items-center gap-3 mb-1">
        <Bitcoin className="w-5 h-5 text-orange-500" />
        <span className="text-xs font-mono-fin uppercase tracking-[0.3em] text-[#D91E2A] font-bold">Digital Assets</span>
      </div>
      <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 mb-2">Crypto Markets</h1>
      <p className="text-slate-600 mb-8 max-w-2xl text-sm sm:text-base">Live prices for Bitcoin, Ethereum and top altcoins alongside curated crypto news from India & global desks.</p>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-10" data-testid="crypto-grid">
        {items.map(c => {
          const up = (c.change || 0) >= 0;
          return (
            <div key={c.symbol} className="rounded-xl bg-white border border-slate-200 p-5 card-glow" data-testid={`crypto-card-${c.symbol.toLowerCase()}`}>
              <div className="flex items-center justify-between mb-2">
                <div>
                  <div className="text-xs font-mono-fin uppercase tracking-wider text-slate-500 font-semibold">{c.symbol}</div>
                  <div className="text-[10px] font-mono-fin text-slate-400 mt-0.5">{c.yf_symbol}</div>
                </div>
                <span className="text-2xl font-bold text-slate-300">{ICON[c.symbol] || "◆"}</span>
              </div>
              <div className="font-mono-fin text-xl text-slate-900 font-bold">${c.price?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
              <div className={`font-mono-fin text-xs mt-1 font-semibold ${up ? "text-emerald-600" : "text-rose-600"}`}>
                {up ? "▲" : "▼"} {Math.abs(c.change).toFixed(2)} ({Math.abs(c.change_pct).toFixed(2)}%)
              </div>
            </div>
          );
        })}
      </div>

      <h2 className="font-heading font-bold text-xl sm:text-2xl text-slate-900 mb-4">Crypto News</h2>
      <LiveNewsFeed limit={20} defaultCategory="Crypto" />
    </div>
  );
}
